import * as React from 'react'

import { Box, Icon, Popover, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface AgreementHoursProps {
  contractMinutes: number
  balanceFromContract: number
  rangeIncludesToday: boolean
  adjustedDailyMinutes?: number | null
}

const AgreementHours = ({
  contractMinutes,
  balanceFromContract,
  rangeIncludesToday,
  adjustedDailyMinutes,
}: AgreementHoursProps) => {
  const [hover, setHover] = React.useState<boolean>(false)
  const periodEndLabel = adjustedDailyMinutes
    ? i18n.t('clock_in.bank_of_hours.counters.until_sunday')
    : i18n.t('clock_in.bank_of_hours.counters.until_today')

  const periodEndText = rangeIncludesToday ? periodEndLabel : undefined

  return (
    <Box flexDirection="row" gap="s4" flexGrow>
      <Icon.Medium color="grey1000" icon="contract" />
      <Box gap="s2">
        <Box flexDirection="row" gap="s4" alignItems="baseline">
          <Text.Normal color="grey1000" weight="medium">
            {i18n.t('clock_in.bank_of_hours.counters.agreement_hours.title')}
          </Text.Normal>
          {periodEndText && <Text size="100">{periodEndText}</Text>}
        </Box>
        <Box flexDirection="row" gap="s8">
          <MinutesToText color="grey1000" value={contractMinutes} size="500" weight="medium" />
          {balanceFromContract !== 0 && (
            <Box
              paddingY="s4"
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              <Popover.ItemList
                gapDivider={false}
                attachment="bottom center"
                open={hover}
                toggle={() => () => undefined}
              >
                <Tag type={Tag.Types.radical} leftItem="icon" icon="alert-circle">
                  <MinutesToText
                    color="grey1000"
                    size="200"
                    weight="medium"
                    value={balanceFromContract}
                  />
                </Tag>
                <Box textAlign="left">
                  <Text color="grey000White" weight="medium" size="200">
                    {i18n.t('clock_in.bank_of_hours.counters.agreement_hours.tag_description')}
                  </Text>
                </Box>
              </Popover.ItemList>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default AgreementHours
